type ObjectConstructorWithHasOwn = typeof Object & {
  hasOwn?: (object: object, property: PropertyKey) => boolean
}

const objectConstructor = Object as ObjectConstructorWithHasOwn

export const installObjectHasOwnPolyfill = (): void => {
  if (typeof objectConstructor.hasOwn === 'function') return

  Object.defineProperty(objectConstructor, 'hasOwn', {
    configurable: true,
    writable: true,
    value: (object: object, property: PropertyKey): boolean =>
      Object.prototype.hasOwnProperty.call(object, property)
  })
}
